import { render, staticRenderFns } from "./BrandingPlayerPreview.vue?vue&type=template&id=28fa2890"
import script from "./BrandingPlayerPreview.vue?vue&type=script&lang=js"
export * from "./BrandingPlayerPreview.vue?vue&type=script&lang=js"
import style0 from "./BrandingPlayerPreview.vue?vue&type=style&index=0&id=28fa2890&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports